<template>
  <div class="h-pm-gnb-dataQuery-tree">
    <ejs-treeview ref='gnbPmDataQueryTree' :fields='fieldsOfGnbPmDataQueryTree' :nodeSelected="nodeSelectedOfGnbPmDataQueryTree"></ejs-treeview>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapGetters, mapMutations } = createNamespacedHelpers('mmlconfig');
export default {
  name: 'PmNoRealDataQueryLeftTree',
  components: {
  },
  data() {
    return {
      fieldsOfGnbPmDataQueryTree: {
        dataSource: [],
        id: 'id',
        parentID: 'parentId',
        text: 'name',
        hasChildren: 'hasChildren',
        expanded: 'expanded'
      }
    }
  },
  computed :{
     ...mapGetters(['currentNe']),
  },
  methods: {
    ...mapMutations(['changeCurrentNe']),

    nodeSelectedOfGnbPmDataQueryTree(args){
      const params = this.$refs.gnbPmDataQueryTree.getTreeData(args.nodeData.id)[0];
      console.log(params)
      this.changeCurrentNe(params)
      this.$emit('gnbPmDataQueryTreeClickEventPush', params);
    },

    initGnbPmDataQueryTree(){
      this.$axios.get('/lte/ems/config/mml/getGnbPmDataQueryTree.html').then((response) => {
        this.fieldsOfGnbPmDataQueryTree = {
          dataSource: response.data.resultVal,
          id: 'id',
          parentID: 'parentId',
          text: 'name',
          hasChildren: 'hasChildren',
          expanded: 'expanded'
        };
      });
    }
  },
  mounted() {
    this.initGnbPmDataQueryTree();
  }
};
</script>

<style>

</style>
